<mat-icon *ngIf="icon">{{ icon }}</mat-icon>
<ng-content></ng-content>
